__webpack_require__.p = "https://accounts-cdn.stage.mozaws.net/settings/stage/";